import request from './request';

export const fetchWebBasic = (wine, market) =>
  request({
    method: 'GET',
    url: `/web/premium/overview?no_page${
      wine ? '&wines=["' + wine + '"]' : ''
    }${market ? '&market=' + market : ''}`,
    protectedRoute: true,
    newApi: true
  });

export const fetchWebDetailed = (vintage, wine, market) =>
  request({
    method: 'GET',
    url: `/web/premium/details?no_page${vintage ? '&vintage=' + vintage : ''}${
      wine ? '&wines=["' + wine + '"]' : ''
    }${market ? '&market=' + market : ''}`,
    protectedRoute: true,
    newApi: true
  });

export const fetchPmcs = () =>
  request({
    method: 'GET',
    url: '/web/pmc?',
    protectedRoute: true,
    newApi: true
  });

export const updatePmcs = (data) =>
  request({
    method: 'POST',
    data,
    url: '/web/pmc',
    protectedRoute: true,
    newApi: true
  });
